import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "./Navbar";
import Footer from "./Footer";

const MentionsLegales = () => {
  return (
    <div className="page">
      <Helmet>
        <title>Mentions légales – Deenzine</title>
        <meta name="description" content="Mentions légales du site Deenzine." />
        <link rel="canonical" href={window.location.origin + "/mentions-legales"} />
      </Helmet>

      <Navbar />

      <section className="section">
        <div className="container">
          <div className="card cardPad" style={{ maxWidth: 900, margin: "0 auto" }}>
            <h1 className="h2" style={{ color: "var(--brand)" }}>Mentions légales</h1>

            <p className="p">
              <strong>Éditeur du site :</strong><br />
              Site développé et maintenu par MynassiaDigital (SIREN/SIRET : à compléter).<br />
              Responsable de la publication : Myriam OMARI – contact : <strong>une.developpeuse01@gmail.com</strong>
            </p>

            <div className="hr" />

            <p className="p">
              <strong>Propriétaire de la marque :</strong><br />
              La marque « DeenZine » est la propriété exclusive de son créateur et détenteur légal.
            </p>

            <div className="hr" />

            <p className="p">
              <strong>Hébergement :</strong><br />
              o2switch – 222 Boulevard Gustave Flaubert, 63000 Clermont-Ferrand
            </p>

            <div className="hr" />

            <p className="p">
              <strong>Protection :</strong><br />
              Toute reproduction, utilisation ou exploitation des éléments du site sans autorisation est interdite.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MentionsLegales;
